import { Customer } from "@/services/api";
import * as React from "react";

export interface IPortalContext {
	pagePrefix: string;
	selectedCustomerId?: string | null;
	setSelectedCustomerId?: (cust: string | null | undefined) => void;
}
export const PortalContext = React.createContext<IPortalContext>({
	pagePrefix: "",
	selectedCustomerId: null,
	setSelectedCustomerId: () => {},
});

export function usePortalContext() {
	return React.useContext(PortalContext);
}
